<script setup lang="ts">
import type { RadioGroupItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { useForwardProps } from 'reka-ui';
import SphLabel from '@/components/base/label/';
import generateId from '@/utils/generateId';
import { cn } from '@/utils/shadcn/lib/utils.ts';
import RadioGroupItem from './RadioGroupItem.vue';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
    inheritAttrs: true,
});

const props = defineProps<RadioGroupItemProps & {
    class?: HTMLAttributes['class']
    value: any
    label: string
    description?: string
    checked?: boolean
}>();

const itemId = generateId('radio-group');

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <div
        data-slot="radio-group-item-text"
        :class="cn('px-1 py-1 cursor-pointer group-data-disabled/radio-group:pointer-events-none group-data-[orientation=horizontal]/radio-group:px-2', props.class)"
    >
        <SphLabel
            :for="itemId"
            inline
            data-slot="radio-group-item-label"
            class="cursor-pointer group-data-disabled/radio-group:opacity-50"
        >
            <RadioGroupItem
                v-bind="forwardedProps"
                :id="itemId"
                :value="props.value"
                class="mr-2"
            />

            <span>
                {{ props.label }}
            </span>
        </SphLabel>
    </div>
</template>
